module.exports = __webpack_public_path__ + "assets/MapMarker-4652a0.svg";